import type { DisplayExchange, ExchangePhase } from '../types/displayExchange';
import type { SessionStatus, TimelineItem } from '../types/session.types';
import type { ConversationTranscript } from '../types/transcript.types';

export function buildTranscriptExchanges(input: {
  transcript: ConversationTranscript | undefined;
  liveTimeline: TimelineItem[];
  sessionStatus: SessionStatus | null;
  sessionConversationId: string | null;
}): DisplayExchange[] {
  if (!input.transcript) return [];

  const exchanges: DisplayExchange[] = [
    ...input.transcript.baseExchanges,
    ...input.transcript.committedExchanges,
  ];

  if (!input.transcript.activeTurn) {
    return exchanges;
  }

  const ownsLiveTimeline = input.sessionConversationId === input.transcript.conversationId;
  const activeTimeline = ownsLiveTimeline ? [...input.liveTimeline] : [];

  return [
    ...exchanges,
    {
      id: `turn:${input.transcript.activeTurn.localTurnId}`,
      userMessage: input.transcript.activeTurn.userMessage,
      timeline: activeTimeline,
      phase: mapActivePhase(activeTimeline, input.sessionStatus),
      ...(input.transcript.activeTurn.caseId !== undefined
        ? { caseId: input.transcript.activeTurn.caseId }
        : {}),
      ...(input.transcript.activeTurn.uiActionCapabilities !== undefined
        ? { uiActionCapabilities: [...input.transcript.activeTurn.uiActionCapabilities] }
        : {}),
    },
  ];
}

function mapActivePhase(timeline: TimelineItem[], sessionStatus: SessionStatus | null): ExchangePhase {
  if (timeline.length === 0) return 'live_pending';
  if (sessionStatus === 'ready' || sessionStatus === 'error') return 'live_done';
  return 'live_streaming';
}
